<template>
    <BasicModalWindow>
        <template #title>
            <span>{{Language.say('messages.open.source_code')}} - {{message.subject}}</span>
        </template>

        <template #body>
            <ContentLoading v-if="loading" />

            <ContentError v-else-if="!source"
              @contentErrorRetry="onErrorRetry()"
            />

            <slot v-else>
                <pre style="word-wrap: break-word; white-space: pre-wrap;">{{source}}</pre>
            </slot>

        </template>
    </BasicModalWindow>
</template>

<script setup>
  import {defineProps, onBeforeMount, ref} from 'vue';
  import ContentLoading                    from '@/vue/Elements/Content/ContentLoading.vue';
  import ContentError                      from '@/vue/Elements/Content/ContentError.vue';
  import BasicModalWindow                  from '@/vue/Layouts/Modals/BasicModalWindow.vue';
  import Language                          from '@/js/Shared/Language/Language.js';

  const source  = ref(null);
  const loading = ref(true)
  const props   = defineProps({
    message            : {},
    folder_id          : {},
    viewport_controller: {},
  })

  onBeforeMount(async () => {
    await fetchSource();
  })

  const onErrorRetry = async () => {
    await fetchSource();
  }

  const fetchSource = async () => {
    loading.value = true;
    source.value  = await props.viewport_controller.fetchMessageSource(props.folder_id, props.message.id);
    loading.value = false
  }
</script>